import * as Actions from "./actions";
import ApiService from "../../../../utils/apiService";
import * as Path from './apiRoutes';

const fetchDefault = (payload) => (dispatch) => {
    let params = new URLSearchParams();
    Object.keys(payload).map((key) =>
        params.append(key, payload[key])
    );

    return ApiService.get(Path.ORDER_SHOPS_GET_LIST, params)
        .then((response) => {
            dispatch(Actions.setList(response.data.data));
        }).catch(()=>{
            dispatch(Actions.setList([])); 
        })
};

export {
    fetchDefault
};
